<template>
  <div id="pers-topic" name="hres31x-topic">
	  <div class="main-topic-box">
      <i class="left-arrow fa fa-angle-left" aria-hidden="true" @click.stop="onArrowLeft()"></i>
      <div class="main-topic" @click="toggleMenuMobile()">{{ nameTopic(page) }}</div>
      <i class="right-arrow fa fa-angle-right" aria-hidden="true" @click.stop="onArrowRight()"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hres31x-topic',
  methods: {
    nameTopic (page) {
      if (page === 1) {
        return this.labels['HRRC21P1']['0']
      }
      if (page === 2) {
        return this.labels['HRES31XC1']['290']
      }
      if (page === 3) {
        return this.labels['HRES31XC1']['300']
      }
      if (page === 4) {
        return this.labels['HRES31XC1']['310']
      }
      if (page === 5) {
        return this.labels['HRES31XC1']['320']
      }
      if (page === 6) {
        return this.labels['HRES31XC1']['330']
      }
      if (page === 7) {
        return this.labels['HRES31XC1']['340']
      }
      if (page === 8) {
        return this.labels['HRES31XC1']['350']
      }
      if (page === 9) {
        return this.labels['HRES31XC1']['360']
      }
      if (page === 10) {
        return this.labels['HRES31XC1']['370']
      }
      if (page === 11) {
        return this.labels['HRES31XC1']['380']
      }
      if (page === 12) {
        return this.labels['HRES31XC1']['390']
      }
      if (page === 13) {
        return this.labels['HRES31XC1']['400']
      }
      if (page === 14) {
        return this.labels['HRES31XC1']['410']
      }
      if (page === 15) {
        return this.labels['HRES31XC1']['420']
      }
      if (page === 16) {
        return this.labels['HRES31XC1']['430']
      }
      if (page === 17) {
        return this.labels['HRES31XC1']['440']
      }
      if (page === 18) {
        return this.labels['HRES31XC1']['450']
      }
      if (page === 19) {
        return this.labels['HRES31XC1']['460']
      }
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'page', 'toggleMenuMobile', 'onArrowLeft', 'onArrowRight' ]
}
</script>


// WEBPACK FOOTER //
// topic.vue?49e17454